import {client} from './services/client'
/*eslint-disable*/
export const reversements = {
    namespaced: true,
    state: {
        reversements_configs: undefined,
        reversemeneas: undefined,
        reversementeff: undefined,
        reversementref: undefined,
        reversements:undefined
    },
    mutations: {
        SET_REVERSEMENT_CONFIGS(state, reversements_configs) {
            state.reversements_configs = reversements_configs
        },
        SET_REVERSEMENTEA(state, reversements) {
            state.reversemeneas = reversements
        },

        SET_REVERSEMENTEFF(state, reversements) {
            state.reversementeff = reversements
        },

        SET_REVERSEMENTREF(state, reversements) {
            state.reversements = reversements
        },

        SET_REVERSEMENT(state, reversements) {
            state.reversements = reversements
        },


    },
    actions: {
        getReversements({commit}, role) {
            return new Promise((resolve, reject) => {
                client({
                    method: 'get',
                    url: '/reversements/get/'+role,
                })
                    .then((response) => {
                        commit('SET_REVERSEMENT', response.data.reversements);
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })

        },
        getReversementConfigsForAdmin({commit}) {
            return new Promise((resolve, reject) => {
                client({
                    method: 'get',
                    url: '/reversements/getReversementForAdmin',
                })
                    .then((response) => {
                        let reversements_configs = response.data.reversements_configs;
                        commit('SET_REVERSEMENT_CONFIGS', reversements_configs);
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })

        },
        getReversementsEnAttente({commit}, data) {
            return new Promise((resolve, reject) => {
                client({
                    method: 'post',
                    url: '/reversements/by/status/get',
                    data: data
                })
                    .then((response) => {
                        let reversements = response.data.reversements;
                        let status = response.data.status;

                        switch (status){

                            case "en_attente":
                                commit('SET_REVERSEMENTEA', reversements);
                                break;

                            case "success":
                                commit('SET_REVERSEMENTEFF', reversements);
                                break;


                                case "refuser":
                                commit('SET_REVERSEMENTREF', reversements);
                                break;



                        }


                    })
                    .catch((error) => {
                        reject(error);
                    })
            })

        },
        updateStatus({commit}, data) {
            return new Promise((resolve, reject) => {
                client({
                    method: 'post',
                    url: '/reversements/status/update',
                    data: data
                })
                    .then((response) => {

                        commit('SET_REVERSEMENTEA',  response.data.rev1);
                        commit('SET_REVERSEMENTEFF', response.data.rev2);
                        commit('SET_REVERSEMENTREF', response.data.rev3);

                    })
                    .catch((error) => {
                        reject(error);
                    })
            })

        },
        getUpdateCancel({commit}, data) {
            return new Promise((resolve, reject) => {
                client({
                    method: 'post',
                    url: '/reversements/update/cancel',
                    data: data,
                })
                    .then((response) => {
                        let reversements = response.data.reversements;
                        commit('SET_REVERSEMENT', reversements);

                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    })
            });
        },
        setReversement({commit}, data) {
            return new Promise((resolve, reject) => {
                client({
                    method: 'post',
                    url: '/reversements/save',
                    data: data,
                })
                    .then((response) => {
                        let reversements = response.data.reversements;
                        commit('SET_REVERSEMENT', reversements);

                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    })
            });
        },
        deleteReversement({commit}, id) {
            return new Promise((resolve, reject) => {
                client({
                    method: 'get',
                    url: '/reversements/delete/' + id,
                })
                    .then((response) => {
                        let reversements = response.data.reversements;
                        commit('SET_REVERSEMENT', reversements);
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
        performReversements({commit},type) {
            return new Promise((resolve, reject) => {
                client({
                    method: 'get',
                    url: '/reversements/perform/'+type,
                })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    })
            })

        },
    },
    getters: {
        getReversements: state => {
            return state.reversements
        },
        getReversementsEnAttente: state => {
            return state.reversemeneas
        },

    }
};
